import React, { useState } from "react";
import {
  Box,
  Typography,
  styled,
  TextField,
  FormHelperText,
  Stack,
  MenuItem,
  Button,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import BannerImage from "../../component/admin/professionalTournaments/BannerImage";
import GoalVideoUpload from "../../component/admin/professionalTournaments/GoalVideoUpload";
import { addProfessionalTournament } from "../../api/addProfessionalTournament";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ProfessionalTournamentForm from "../../component/admin/formComponents/ProfessionalTournamentForm";
import { TurnLeft } from "@mui/icons-material";
import { useAuth } from "../../context/auth";
import { generateRandomNumber } from "../../helper/generateRandom";

const AddProfessionalTournament = () => {
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState("");

  const [goalVideos, setGoalVideos] = useState([
    {
      goal: "",
      goal_image: "",
      club_name: "",
      goal_scorer: "",
      checked: false,
      edited: true,
      error: "",
      key_Id: generateRandomNumber(5),
    },
  ]);

  const { goalFormState, setGoalFormState } = useAuth();

  // "";
  const [formErrors, setFormErrors] = useState(false);

  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      yt_link: "",
      category: 1,
      image: "",
      video: [],
      YTVideo: "",
      // category: "default",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Title is required"),
      description: Yup.string().required("Description is required"),
      yt_link: Yup.string(),
      // category: Yup.number().required("Category is required"),
      image: Yup.mixed().required("Banner Image is required"),
    }),
    validateOnChange: true,
    onSubmit: async (values) => {
      const video_meta = [];
      const videos = [];

      let error = false;

      if (formErrors) {
        setErrorState("Please add the goal videos");
        return;
      } else {
        setErrorState("");
      }

      goalVideos.map((prev, index) => {
        if (
          prev.checked &&
          prev.goal_image &&
          prev.goal_scorer.trim() !== "" &&
          prev.club_name.trim() !== ""
        ) {
          return prev;
        } else {
          // "";
          error = true;
          // setSumitForms(false);
          return { ...prev, error: "Please add the goal video" };
        }
      });

      if (error) {
        setErrorState("Please add the goal videos");
        // toast.error("Please add the goal videos");
        return;
      } else {
        setErrorState("");
      }

      goalVideos.map((data, index) => {
        videos.push(data.goal);
        video_meta.push({
          club_name: data.club_name,
          goal_scorer: data.goal_scorer,
          goal_image: data.goal_image,
        });
      });

      const data = {
        title: values.title,
        type: values.category,
        video: videos,
        description: values.description,
        image: values.image,
        ytLink: values.yt_link,
        YTVideo: values.YTVideo,
        category: values.category,
        video_meta: video_meta,
        goalVideos, // add this
      };

      try {
        setLoading(true);
        let resdata = await addProfessionalTournament(data, token);

        if (resdata.success) {
          toast.success(resdata.message);
          navigate("/admin/dashboard/international-tournament");
        } else {
          toast.error(resdata.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <ToastContainer />
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress sx={{ color: "#ef364e" }} />
      </Backdrop>
      <Box className="page_title tournament_title">
        <Typography variant="h1" component="h1">
          Add International Tournaments
        </Typography>
      </Box>

      <ProfessionalTournamentForm
        formik={formik}
        edited={false}
        goalVideos={goalVideos}
        setGoalVideos={setGoalVideos}
        setErrorState={setErrorState}
        setFormErrors={setFormErrors}
      />
      {errorState && (
        <FormHelperText sx={{ color: "red" }}>{errorState}</FormHelperText>
      )}
    </>
  );
};

export default AddProfessionalTournament;
